import React from 'react';

export type ButtonVariant = 'default' | 'primary' | 'ghost';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: ButtonVariant;
  className?: string;
}

/**
 * Button component with multiple variants
 * Variants:
 * - default: Standard button with subtle styling
 * - primary: Fire accent button for primary actions
 * - ghost: Minimal button with no background
 */
export const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'default', 
  className = '',
  ...props 
}) => {
  const variantClass = variant === 'primary' ? 'buttonPrimary' : '';
  const ghostStyles = variant === 'ghost' ? {
    background: 'transparent',
    border: 'none',
    padding: 'var(--s-2)',
  } : {};

  return (
    <button 
      className={`button ${variantClass} ${className}`}
      style={ghostStyles}
      {...props}
    >
      {children}
    </button>
  );
};
